import { render, staticRenderFns } from "./mktCharacteristicDetailNeeded.vue?vue&type=template&id=46cfcb1f&"
import script from "./mktCharacteristicDetailNeeded.vue?vue&type=script&lang=js&"
export * from "./mktCharacteristicDetailNeeded.vue?vue&type=script&lang=js&"
import style0 from "./mktCharacteristicDetailNeeded.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports